<cap-content-header>
  <cap-title>
    {{ "gebaeude.SucheTitel" | translate }}
  </cap-title>
</cap-content-header>

<ul [(activeId)]="searchMode" #nav="ngbNav" class="nav-tabs" ngbNav>
  <li [ngbNavItem]="'searchStandard'">
    <a ngbNavLink>{{ "Standardsuche" | translate }}</a>
    <ng-template id="standard" ngbNavContent>
      <cap-gebaeude-suche-standard></cap-gebaeude-suche-standard>
    </ng-template>
  </li>

  <li [ngbNavItem]="'searchFachId'">
    <a ngbNavLink>{{ (isAvPlusActive ? "gebaeude.EgidKantGid" : "EGID") | translate }}</a>
    <ng-template id="erweitert" ngbNavContent>
      <cap-gebaeude-suche-egid-kantgid></cap-gebaeude-suche-egid-kantgid>
    </ng-template>
  </li>
</ul>
<div [ngbNavOutlet]="nav" class="mt-2"></div>
